<script lang="ts">
	import type { SbMuxVideo } from '$lib/storyblok/types';
	import { onMount } from 'svelte';
	import { slideIn } from '$lib/actions/slideIn';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '$lib/storyblok/editable';
	import Blok from '$lib/storyblok/blok.svelte';

	interface Props {
		content: ISbStoryData<{
			video: ISbStoryData<SbMuxVideo>['content'][];
			eyebrow: string;
			label: string;
		}>['content'];
		delay?: number;
	}

	let { content, delay = 0 }: Props = $props();

	onMount(() => {
		if (content.video.length === 0) return;

		// overwrite some settings
		content.video[0].control_fullscreen_top_right = true;
		content.video[0].rounded_corners = 'xl';
	});
</script>

<div
	use:editable={content}
	use:slideIn={{ delay }}
	class="relative min-h-[230px] overflow-hidden rounded-xl opacity-[0.01] lg:min-h-[372px]"
>
	{#if content.video && content.video.length > 0}
		<Blok content={content.video[0]} />
	{/if}
	<article class="absolute inset-x-0 bottom-0 p-3 text-white lg:p-5">
		<div
			class="mb-1 text-[10px]/[100%] font-semibold uppercase tracking-[.8px] lg:text-[12px]/[100%] lg:tracking-[.96px]"
		>
			{content.eyebrow}
		</div>
		<h1 class="text-[24px]/[108%] tracking-[-.24px] lg:text-[32px]/[110%] lg:tracking-[-.32px]">
			{content.label}
		</h1>
	</article>
</div>

<style>
	article {
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);
	}
</style>
